/* @ngInject */
function TaskStatusBadgeController ($translate) {
  var ctrl = this

  ctrl.formatTaskStatus = function (task) {
    if (!task || !task.status) {
      return
    }

    const status = task.status

    switch (true) {
      case status === 'WAITING_RESPONSE':
        ctrl.color = 'waiting'
        return $translate.instant('waitingApproval')
      case status === 'PROGRESS':
        ctrl.color = 'in-progress'
        return $translate.instant('inProgress')
      case status === 'REVIEW':
        ctrl.color = 'review'
        return $translate.instant('underReview')
      case status === 'DONE':
        ctrl.color = 'done'
        return $translate.instant('done')
      case status === 'REJECTED':
        ctrl.color = 'rejected'
        return $translate.instant('rejected')
      case status === 'WAITING_ADM_ADJUST':
        ctrl.color = 'adjustments'
        return $translate.instant('adjustments')
      case status === 'WAITING_USER_ADJUST':
        ctrl.color = 'adjustments'
        return $translate.instant('adjustments')
    }
  }
}

export { TaskStatusBadgeController }
